<template>
    <div id="footer" v-if="!route.meta.notUseFooter" :class="route.meta.notUseTabBar ? '' : 'mb-64'">
        <div class="pc-max-width w-full bg-[#303132] px-16 py-48 flex flex-col gap-20">
            <div class="flex flex-col gap-10 w-full">
                <div class="flex flex-col gap-20 justify-between">
                    <icon-logo-white />
                    <div class="flex w-fit">
                        <div
                            v-for="item in languages"
                            class="p-10 rounded-5 cursor-pointer text-center text-12"
                            :class="language === item.value ? 'text-white bg-gray3' : 'text-gray1'"
                            @click="changeLang(item.value)"
                        >
                            {{ item.text }}
                        </div>
                    </div>
                </div>
<!--                <div class="flex items-center gap-18">-->
<!--                    <p-->
<!--                        class="flex items-center h-[48px] text-white text-14 cursor-pointer"-->
<!--                        @click="$router.push({-->
<!--                            name: 'terms-type',-->
<!--                            params: {-->
<!--                                type: 'use'-->
<!--                            }-->
<!--                        })"-->
<!--                    >-->
<!--                        {{ $t('company.term.USE') }}-->
<!--                    </p>-->
<!--                    <p-->
<!--                        class="flex items-center h-[48px] text-white text-14 cursor-pointer" -->
<!--                        @click="$router.push({-->
<!--                            name: 'terms-type',-->
<!--                            params: {-->
<!--                                type: 'privacy',-->
<!--                            }-->
<!--                        })"-->
<!--                    >-->
<!--                        {{ $t('company.term.PRIVACY') }}-->
<!--                    </p>-->
<!--                </div>-->
            </div>

<!--            <div class="flex flex-col gap-4 w-full">-->
<!--                <p class="text-14 text-white leading-20 font-medium">메인 텍스트</p>-->
<!--                <p class="text-12 text-gray1 leading-18">서브 텍스트</p>-->
<!--            </div>-->

<!--            <div class="flex items-center justify-center w-full">-->
<!--                <p-->
<!--                    class="flex flex-1 items-center justify-center h-[40px] text-14 text-white leading-17 cursor-pointer" -->
<!--                    @click="$router.push({name: 'notice'})"-->
<!--                >-->
<!--                    {{ $t('board.notice') }}-->
<!--                </p>-->
<!--                <p-->
<!--                    class="flex flex-1 items-center justify-center h-[40px] text-14 text-white leading-17 cursor-pointer" -->
<!--                    @click="$router.push({name: 'faq'})"-->
<!--                >-->
<!--                    {{ $t('board.faq') }}-->
<!--                </p>-->
<!--                <p-->
<!--                    class="flex flex-1 items-center justify-center h-[40px] text-14 text-white leading-17 cursor-pointer"-->
<!--                >-->
<!--                    {{ $t('board.about_us') }}-->
<!--                </p>-->
<!--            </div>-->

            <hr class="border-gray1 opacity-20"/>
            <div class="flex flex-col gap-10">
                <div class="flex gap-10">
                    <icon-x
                        @click="openWindow('https://x.com/dressdio_global')"
                        class="cursor-pointer"
                    />
                    <icon-paper-plane
                        @click="openWindow('https://t.me/DRESSdio_Official')"
                        class="cursor-pointer"
                    />
                </div>
                <p class="text-12 text-white">email : official@dressdio.io</p>
                <p class="text-12 text-white">Fashion Doore Pte. Ltd.</p>
            </div>

<!--            <div class="flex flex-col gap-2 w-full">-->
<!--                <p class="text-12 text-gray1 leading-18">-->
<!--                    {{ company?.name }} / {{ company?.ceo }} / {{ company?.address }} {{ company?.detail_address }}-->
<!--                </p>-->
<!--                <p class="text-12 text-gray1 leading-18">-->
<!--                    {{ $t('company.columns.business_number') }} : {{ company?.business_number }}-->
<!--                </p>-->
<!--                <p class="text-12 text-gray1 leading-18">-->
<!--                    {{ $t('company.columns.mail_order_sales_registration_number') }} : {{ company?.mail_order_sales_registration_number }}-->
<!--                </p>-->
<!--                <p class="text-12 text-gray1 leading-18">-->
<!--                    {{ $t('company.columns.personal_information_protection_officer') }} : {{ company?.personal_information_protection_officer }} / Tel {{ company?.contact }}-->
<!--                </p>-->
<!--                <p class="text-12 text-gray1 leading-18">-->
<!--                    {{ $t('company.columns.email') }} : {{ company?.email }}-->
<!--                </p>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script setup lang="ts">
const { t, locale } = useI18n();
const language = ref(localStorage.getItem('LOCALE_LANGUAGE') ?? navigator.language.slice(0, 2));
const key = ref(new Date().getTime());

// route
const route = useRoute();
const router = useRouter();

// store
const companyStore = useCompanyStore();

// computed
const company = computed(() => companyStore.company);

// data
const languages = ref([
    {
        value: 'ko',
        text: '한국어'
    },
    {
        value: 'en',
        text: 'English'
    },
    {
        value: 'cn',
        text: '简体'
    },
]);

// method
const changeLang = (lang: string) => {
    localStorage.setItem('LOCALE_LANGUAGE', lang);
    language.value = lang;
    locale.value = lang;
    key.value = new Date().getTime();
};

// lifecycle
onMounted(() => {
    companyStore.getCompany();
})
</script>
